import { useElementWidth, useDebouncedValue, useCustomEffect } from "hooks";
export default function useGraphRender(data, containerRef, renderGraph) {
  var width = useElementWidth(containerRef); //only exists to trigger a rerender when it's own state updates

  var debouncedData = useDebouncedValue(200, data);
  useCustomEffect(function () {
    renderGraph();
  }, [debouncedData, width]);
}